import { S, isAmbassador, isStaff, on, render } from "../state";
import { avatar, badge, esc, pinFor } from "../ui";
import { showPaomThanks } from "../seasoncard";
import { fmtDay, fmtTime } from "../../shared/constants";
import { allEvents, ensureYear, mySignup, sortEv } from "../events";
import { calendar, erow } from "./calendar";
import { noShowCount, todaysCheckins } from "./checkin";

function isBirthday() {
  const u = S.me!.user;
  if (!u.birthMonth || !u.birthDay) return false;
  const [, m, d] = S.me!.today.split("-").map(Number);
  return m === u.birthMonth && d === u.birthDay;
}

export function homeView() {
  const me = S.me!;
  const u = me.user;
  const today = me.today;
  // calendar() loads the month on screen; make sure this school year is loaded for the cards too.
  void ensureYear(today).then((fresh) => fresh && render(), () => {});
  const ev = allEvents().filter((e) => e.date >= today);
  const bday = isBirthday()
    ? `<div class="row between wrap"><h1>Happy Birthday, ${esc(u.first)}! 🎉</h1><button class="btn ghost sm" data-act="bday-replay">Celebrate Again</button></div>`
    : "";
  // Admissions sees every active login message (Peter's spec: "Admissions see all of them").
  const msgs = isStaff() && me.loginMessages.length
    ? `<div class="card"><h2>Login Messages</h2><p class="muted small" style="margin:4px 0 8px">What PAs and SAs see when they open the site.</p><ul class="list">${me.loginMessages
        .map((m) => `<li><span class="chip blue" style="margin-bottom:6px">${m.audience === "both" ? "PAs and SAs" : m.audience === "PA" ? "Parent Ambassadors" : "Student Ambassadors"}</span><div class="small" style="white-space:pre-wrap">${esc(m.body)}</div></li>`)
        .join("")}</ul></div>`
    : "";

  let staffBlock = "";
  let ciBlock = "";
  if (isStaff()) {
    const todays = todaysCheckins();
    ciBlock = `<div class="card" style="border-color:var(--primary)">
      <div class="row between"><h2>Today's Check-ins</h2><span class="chip blue">${todays.length} event${todays.length === 1 ? "" : "s"}</span></div>
      ${todays.map((e) => `<div class="row between" style="margin-top:12px"><div><b>${esc(e.title)}</b><div class="muted small">${fmtTime(e.start)} · ${e.signups.length} signed up</div></div><a class="btn sm" href="#checkin">Check In</a></div>`).join("") || '<p class="muted" style="margin:8px 0 0">Nothing to check in today.</p>'}
    </div>`;
    const lastMin = ev.filter((e) => e.lastMinute).length;
    const drafts = ev.filter((e) => e.status === "draft").length;
    const ns = noShowCount();
    staffBlock = `<div class="grid" style="grid-template-columns:repeat(3,1fr);gap:10px">
      <div class="card kpi"><span class="muted small">Last-Minute Openings</span><b>${lastMin}</b></div>
      <div class="card kpi"><a href="#checkin" style="color:inherit;text-decoration:none"><span class="muted small">Past No-Shows</span><b>${ns ?? "…"}</b></a></div>
      <div class="card kpi"><a href="#admin" style="color:inherit;text-decoration:none"><span class="muted small">Drafts Not Published</span><b>${drafts}</b></a></div>
    </div>`;
  }

  let mineBlock = "";
  if (isAmbassador()) {
    const mine = ev.filter((e) => e.status === "published" && mySignup(e)).sort(sortEv);
    const next = mine.length ? mine.filter((e) => e.date === mine[0].date) : [];
    // No upcoming sign-ups: just the badge, no empty "Your Next Event" card (Peter, 2026-11-04).
    mineBlock = next.length
      ? `<div class="grid g2" style="align-items:start">
      ${badge(u, S.photoBust)}
      <div class="card"><h2>Your Next Event 🗓️</h2><div class="stack" style="margin-top:12px">${next.map(erow).join("")}</div>
      ${mine.length > next.length ? `<p class="muted small" style="margin:10px 0 0">You're signed up for ${mine.length} upcoming events.</p>` : ""}</div>
    </div>`
      : `<div style="max-width:460px">${badge(u, S.photoBust)}</div>`;
  }

  const urgent = isAmbassador() ? ev.filter((e) => e.lastMinute && e.status === "published" && !mySignup(e)).sort(sortEv) : [];
  const urgentBlock = urgent.length
    ? `<div class="card" style="border:2px solid var(--accent)"><h2 style="color:var(--accent)">Last-Minute Openings</h2>
      <p class="muted small" style="margin:4px 0 12px">An ambassador dropped out and these events are coming up soon.</p>
      <div class="stack">${urgent.map(erow).join("")}</div></div>`
    : "";

  const team = ev.filter((e) => e.type === "team" && e.status === "published").sort(sortEv);
  const teamBlock = team.length
    ? `<div class="card"><h2>Ambassador Team Events</h2>
      <ul class="list" style="margin-top:8px">${team.map((e) => `<li><button class="erow" style="border:0;padding:0;background:none" data-act="open-event" data-id="${e.id}"><div class="body"><b>${esc(e.title)}</b><div class="muted small">${fmtDay(e.date)} · ${fmtTime(e.start)}${e.locationName ? " · " + esc(e.locationName) : ""}</div></div></button></li>`).join("")}</ul></div>`
    : "";

  // Parent Ambassador of the Month, for everyone, while their pin shows. The winner can replay their thank-you.
  const pm = me.paom;
  const paomBlock = pm
    ? `<div class="card paomcard" style="flex:0 1 340px"><h2>Parent Ambassador of the Month</h2>
      <div class="row" style="margin-top:12px;gap:12px">${avatar(pm.userId, "pav pav52")}<div style="flex:1;min-width:0"><b>${esc(`${pm.first} ${pm.last}`)}</b><div class="muted small">${esc(pm.label)}</div></div>${pinFor(pm.userId, 44)}</div>
      ${me.myPaom && pm.userId === u.id ? `<div class="row between small" style="margin-top:10px;gap:8px"><b>That's you! 🤩</b><button class="btn ghost sm" data-act="paom-replay">See Your Thank-You</button></div>` : ""}</div>`
    : "";

  return `<div class="stack">${ciBlock}${bday}
    ${isAmbassador() ? "" : `<div style="max-width:460px">${badge(u, S.photoBust)}</div>`}
    ${staffBlock}${mineBlock}${urgentBlock}${msgs}
    <div class="card">${calendar()}</div>
    ${teamBlock || paomBlock ? `<div class="row wrap" style="align-items:flex-start;gap:14px">${teamBlock.replace('<div class="card">', '<div class="card" style="flex:1 1 320px">')}${paomBlock}</div>` : ""}
  </div>`;
}

on({
  "paom-replay": () => {
    const me = S.me!;
    if (me.myPaom) showPaomThanks(me.myPaom, me.user.first, false);
  },
});
